import React from 'react'
// import MovieReviewComponent from './MovieReviewComponent'
import ArticleReview from './MovieArticle'

const MovieYouSayRating = ({
  Imdb,
  MovieYouSayRatingInput,
  sendYousayRating,
  sendBooleanValueChangeDone,
  inputData,
  sendinputdata,
  // MovieYouSayReviewUrl,
  // MovieYouSayReviewUrlTe,
  // movieReviewArticleTitleEn,
  // movieReviewArticleTitleTe,
}) => {
  const handleRatingChange = event => {
    const data = event.target.value
    if (data === '' || (data >= 1 && data <= 5)) {
      sendBooleanValueChangeDone('MovieYouSayRating', data !== '')
      sendYousayRating('MovieYouSayRating', data === '' ? '' : parseFloat(data, 10))
    } else {
      sendYousayRating('MovieYouSayRating', '')
    }
  }

  const handleInput = event => {
    // Prevent the input value change for non-numeric characters
    if (!isNaN(event.target.value)) {
      event.preventDefault()
    }
  }

  const stopwheelAction = event => {
    event.target.blur()
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <>
      <div className='w-50'>
        <label>
          YouSayRating:<span className='mandatory'>*</span>
        </label>
        <input
          type='number'
          value={MovieYouSayRatingInput}
          className='rounded'
          placeholder='ex: 1.0, 2.7, 3.4, 4.9'
          disabled={Imdb !== ''}
          onChange={handleRatingChange}
          onWheel={event => stopwheelAction(event)}
          onInput={handleInput}
        />
        {Imdb === '' && MovieYouSayRatingInput === '' && (
          <div className='mandatory1'>Provide at least one of IMDb or YouSayRating</div>
        )}
      </div>
      {/* <MovieReviewComponent
        MovieYouSayReviewUrl={MovieYouSayReviewUrl}
        MovieYouSayReviewUrlTe={MovieYouSayReviewUrlTe}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        sendYousayRating={sendYousayRating}
        movieReviewArticleTitleEn={movieReviewArticleTitleEn}
        movieReviewArticleTitleTe={movieReviewArticleTitleTe}
      /> */}
      <ArticleReview
        review={inputData && inputData.yousayArticleReviews}
        inputData={inputData}
        sendinputdata={sendinputdata}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
      />
    </>
  )
}

export default MovieYouSayRating
